module.exports = __webpack_public_path__ + "static/media/Error.70499cbb.svg";